import { Observable, Subject } from "rxjs";

export function loading<T>(loading$: Observable<any>, producer: () => PromiseLike<T>) {
    const result = new Subject<"loading" | T>();

    const subscription = loading$.subscribe({
        next: async () => {
            result.next("loading");
            try {
                const item = await producer();
                result.next(item);
            } catch (e) {
                result.error(e);
                subscription?.unsubscribe();
            }
        },
        complete: () => {
            subscription?.unsubscribe();
            result.complete();
        },
        error: err => {
            subscription?.unsubscribe();
            result.error(err);
        }
    });

    return result.asObservable();
}
